import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-580a3d8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-trv-title" }
const _hoisted_2 = { class: "nge-trv-pos" }
const _hoisted_3 = { class: "nge-trv-line" }
const _hoisted_4 = {
  key: 0,
  class: "nge-trv-err",
  role: "alert"
}
const _hoisted_5 = { class: "nge-trv-how" }
const _hoisted_6 = { class: "nge-trv-legend" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-trv-key nge-trv-key--green" }, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-trv-key nge-trv-key--red" }, null, -1 /* HOISTED */))
const _hoisted_9 = {
  key: 1,
  class: "nge-trv-how"
}
const _hoisted_10 = {
  key: 2,
  class: "nge-trv-how"
}
const _hoisted_11 = {
  key: 3,
  class: "nge-trv-how"
}
const _hoisted_12 = {
  key: 4,
  class: "nge-trv-how"
}
const _hoisted_13 = {
  key: 0,
  class: "nge-trv-sec"
}
const _hoisted_14 = ["aria-expanded", "onClick"]
const _hoisted_15 = { class: "nge-trv-caret" }
const _hoisted_16 = {
  key: 0,
  class: "nge-trv-list"
}
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = {
  key: 0,
  class: "nge-trv-worth"
}
const _hoisted_19 = { class: "nge-trv-nav" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.t && $setup.parts)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "boxEl",
        class: _normalizeClass(["nge-trv", { 'nge-trv--dragging': $setup.dragging }]),
        style: _normalizeStyle($setup.posStyle),
        role: "dialog",
        "aria-label": "A Proofreading Test try"
      }, [
        _createElementVNode("div", {
          class: "nge-trv-head",
          title: "Drag to move",
          onPointerdown: _cache[0] || (_cache[0] = (...args) => ($setup.startDrag && $setup.startDrag(...args)))
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString($setup.playerName($setup.t)), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_2, _toDisplayString($setup.when($setup.t.started_at)), 1 /* TEXT */)
        ], 32 /* HYDRATE_EVENTS */),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("b", null, _toDisplayString($setup.outcomeWord($setup.t)), 1 /* TEXT */),
          ($setup.t.percent != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · " + _toDisplayString($setup.t.percent) + " percent", 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          ($setup.t.timed_out)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" · time ran out")
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        ($setup.reviewProblem)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.reviewProblem), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode("Their cell as they left it, see-through"),
          ($setup.heat.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(", with every scored piece in color")
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createTextVNode(".")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _hoisted_7,
            _createTextVNode("right"),
            ($setup.heat.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" (" + _toDisplayString($setup.heat.filter(c => c === $setup.RIGHT).length) + " pieces)", 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", null, [
            _hoisted_8,
            _createTextVNode("wrong"),
            ($setup.heat.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" (" + _toDisplayString($setup.heat.filter(c => c !== $setup.RIGHT).length) + " pieces)", 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        ($setup.t.given.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Their points: " + _toDisplayString($setup.pts.onEnd.length) + " on an end (green gems), " + _toDisplayString($setup.pts.offEnd.length) + " near no end (red gems). Red pins mark what they missed.", 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("p", _hoisted_10, "They placed no points. Red pins mark what they missed.")),
        (!$setup.heat.length && $setup.t.outcome !== 'expired')
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "This try has no pieces to color: it was scored before the heat map."))
          : _createCommentVNode("v-if", true),
        ($setup.t.outcome === 'expired')
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "They left without submitting: no score, and their branch end points never reached the server."))
          : _createCommentVNode("v-if", true),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SECTIONS, (s) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: s.key
          }, [
            ($setup.has($setup.parts[s.key]))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "nge-trv-sec-head",
                    "aria-expanded": !!$setup.open[s.key],
                    onClick: $event => ($setup.open[s.key] = !$setup.open[s.key])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["nge-trv-dot", `nge-trv-dot--${s.dot}`])
                    }, null, 2 /* CLASS */),
                    _createTextVNode(_toDisplayString(s.title) + " (" + _toDisplayString($setup.parts[s.key].length) + ") ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_15, _toDisplayString($setup.open[s.key] ? '▴' : '▾'), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_14),
                  ($setup.open[s.key])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parts[s.key], (c, i) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: i,
                            class: "nge-trv-fly",
                            disabled: !c.point,
                            title: "Fly there",
                            onClick: $event => ($setup.flyTo(c.point))
                          }, [
                            _createTextVNode(_toDisplayString(c.label), 1 /* TEXT */),
                            (c.kind === 'cut' || c.kind === 'merge')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.n(c.weight)), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ], 8 /* PROPS */, _hoisted_17))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 64 /* STABLE_FRAGMENT */)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "nge-trv-btn",
            title: "Close this panel; their cell stays on screen",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.endTryReview()))
          }, "Close"),
          _createElementVNode("button", {
            class: "nge-trv-btn nge-trv-btn--list",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.backToTries()))
          }, "Back to the tries")
        ])
      ], 6 /* CLASS, STYLE */))
    : _createCommentVNode("v-if", true)
}